// src/utils/extractPhrases.js
// Splits a post body into up to 5 short points an infographic can lay out.
export const extractPhrases = (bodyText) => {
  if (!bodyText) return [];

  let rawPhrases = [];

  // Strategy 1: split on \n\n (bullet list between double newlines)
  const doubleNewlineRegex = /\n\n/g;
  const firstMatch = doubleNewlineRegex.exec(bodyText);

  if (firstMatch) {
    const secondMatch = doubleNewlineRegex.exec(bodyText);
    const bulletBlock = secondMatch
      ? bodyText.slice(firstMatch.index + 2, secondMatch.index).trim()
      : bodyText.slice(firstMatch.index + 2).trim();

    rawPhrases = bulletBlock
      .split("\n")
      .map((p) => p.replace(/^\d+[\.\)●•\-\*]\s*/, "").trim())
      .filter((p) => p.length > 5)
      .filter((p) => !p.endsWith(":"));
  }

  // Strategy 2: split on single \n if strategy 1 didn't find enough
  if (rawPhrases.length < 2) {
    rawPhrases = bodyText
      .split("\n")
      .map((p) => p.replace(/^\d+[\.\)●•\-\*]\s*/, "").trim())
      .filter((p) => p.length > 5)
      .filter((p) => !p.endsWith(":"));
  }

  // Strategy 3: split on bullet characters directly
  if (rawPhrases.length < 2) {
    rawPhrases = bodyText
      .split(/[●•\-\*]/)
      .map((p) => p.replace(/^\d+[\.\)]\s*/, "").trim())
      .filter((p) => p.length > 5)
      .filter((p) => !p.endsWith(":"));
  }

  // Strategy 4: split on sentences as last resort
  if (rawPhrases.length < 2) {
    rawPhrases = bodyText
      .split(/[.!?]+/)
      .map((p) => p.trim())
      .filter((p) => p.length > 10)
      .filter((p) => !p.endsWith(":"));
  }

  // Max 5, no duplicates, no padding
  const uniquePhrases = [...new Set(rawPhrases)];
  return uniquePhrases.slice(0, 5);
};